export default "__VITE_ASSET__a7a441ed__$_?component__"